<template>
  <step-container :auto-scroll="!prevStepAutoFilled">
    <div class="flex flex-col justify-center gap-8">
      <div class="grid gap-8 md:gap-8 mx-4">
        <div v-if="step === 1" class="flex-col items-center gap-2 inline-flex">
          <img height="120" class="h-[120px]" :src="videoTapeIllustration" />
          <div class="text-center text-lg font-medium mb-4">¿Qué hacemos?</div>
          <div>
            <span class="font-medium">Capturamos las historias de un ser querido</span>
            a través de una entrevista grabada con video y audio profesional, donde mediante una conversación emotiva logramos revivir sus mejores recuerdos.
          </div>
        </div>

        <div v-if="step === 2" class="flex-col items-center text-balance gap-2 inline-flex">
          <img height="120" class="h-[120px]" :src="podcastIllustration" />
          <div class="text-center text-lg font-medium mb-4">¿Cómo lo logramos?</div>
          <div>
            Te ayudamos a preparar una entrevista única, conducida por un entrevistador especializado y nos encargamos de la grabación y edición.
          </div>
        </div>

        <div v-if="step === 3" class="flex flex-col items-center md:col-span-2">
          <div class="text-center flex flex-col justify-center gap-1.5">
            <div class="text-lg font-medium">Y como resultado...</div>
            <div class="text-2xl font-bold my-4">Memoorias</div>

            <div class="flex flex-col text-balance items-center gap-2">
              <div>
                Una serie de <span class="font-medium">capítulos</span> alojados en un perfil online privado.
              </div>
              <div class="text-xs font-normal">
                Cada capítulo tiene una duración de 20-30 minutos
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center">
        <div class="mb-5">
          <styled-button :title="buttonTitle" @click="onClick" />
        </div>

        <span class="text-primary-palette cursor-pointer" @click="triggerOpenVideo"
          >¡Escucha testimonios de la experiencia!</span
        >
      </div>
    </div>
  </step-container>
</template>

<script setup>
import podcastIllustration from "@assets/images/podcast.svg";
import videoTapeIllustration from "@assets/images/quotation/video-tape.svg";
</script>

<script>
import stepMixin from "../../mixins/step";

import DetailCard from "../layouts/DetailCard.vue";
import StyledButton from "../layouts/StyledButton.vue";
import StepContainer from "../layouts/StepContainer.vue";

export default {
  mixins: [stepMixin],

  components: {
    DetailCard,
    StyledButton,
    StepContainer,
  },

  data() {
    return {
      step: 1,
      buttonTitle: "Continuar",
    };
  },

  methods: {
    onClick() {
      this.step++;

      if (this.step === 3) this.buttonTitle = "Comencemos";

      if (this.step === 4) this.$emit("input", true);
    },

    triggerOpenVideo() {
      triggerOpenVideoModal();
    },
  },

  computed: {
    mostPopularChapters() {
      return [
        {
          icon: "🧑🏻‍🎓",
          title: "infancia y juventud",
        },
        {
          icon: "👩🏻‍💻",
          title: "vida laboral",
        },
        {
          icon: "❤️",
          title: "vida amorosa",
        },
      ];
    },
    prevStepAutoFilled() {
      const urlParams = new URLSearchParams(window.location.search);
      const motive = urlParams.get("motive");

      if (!motive) return false;

      return true;
    },
  },
};
</script>
